export const  getCountGetter = function  (state, getters) {
            return state.count + " Euro";
                  
}

export const getLayoutRatio = function(state, getters) {
    var ratio = state.layout.width / state.layout.height;
    return Number( ratio.toFixed(2) );
}

export const getWindowMargin = function(state, getters) {

     if(state.layout.type == 'small'  || state.layout.type == 'medium' ) {
         return 0;
     }
     return state.layout.margin;
}


export const getSidebarWidth = function(state, getters) {

     if(state.layout.type == 'small'  || state.layout.type == 'medium' ) {
         return 0;
     }


     if(state.sidebar.status == 2) {

            return state.sidebar.widthExpanded;
     }
     if(state.sidebar.status == 1) {

            return state.sidebar.widthCollapsed;
     }
     if(state.sidebar.status < 1) {

            return state.sidebar.widthHidden;
     }

            return state.sidebar.widthHidden;
}








// WEBPACK FOOTER //
// ./src/components/store/getters.js